export class RegisterEmployer {
    CompanyName: string;
    EmailAddress: string;
    MobileNumber: string;
    Country: string;
    RegisteredCompanyId?: number;
    CreatedBy?: number;
    CreatedDate?: Date;
}